'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC } from 'react'

import { useGlobalConfigContext } from '../../../global-config'
import { useStoryblokStory } from '../../context/StoryblokStoryContext'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokGlossaryOverviewType } from '../../storyblok'

import { CmsGlossaryIndex } from './components/CmsGlossaryIndex'

export const StoryblokGlossaryOverview: FC<
  StoryblokComponentProps<StoryblokGlossaryOverviewType>
> = ({ blok }) => {
  const { enrichedData, glossaryDefinition, story } = useStoryblokStory()
  const { locale } = useGlobalConfigContext()
  const isGlossaryPage = story.content.component === 'GlossaryPage'

  if (!isGlossaryPage) {
    throw new Error(
      `StoryblokGlossaryOverview component can only be used within a GlossaryPage. Current story component: ${story.content.component}`,
    )
  }

  return (
    <CmsGlossaryIndex
      {...storyblokEditable(blok)}
      entries={enrichedData?.glossary?.entries.filter(
        (item) => item.hasEntries,
      )}
      glossaryDefinition={glossaryDefinition}
      locale={locale}
    />
  )
}
